var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconInfobanner1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 67,
    viewBox: "0 0 104 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3377 48.0693C16.3377 48.0693 14.9601 45.0048 7.03906 44.8516C8.83756 54.9644 16.3377 51.5168 16.3377 51.5168V48.0693Z",
    fill: "white",
    fillOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0703 48.0693C16.0703 48.0693 17.4479 45.0048 25.3689 44.8516C23.5704 54.9644 16.0703 51.5168 16.0703 51.5168V48.0693Z",
    fill: "white",
    fillOpacity: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4176 63.8821L14.4992 63.5756C14.5375 63.499 16.9482 55.6846 14.4609 37.4509L15.4559 37.3359C17.9431 55.8378 15.5324 63.5756 15.4176 63.8821Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5789 41.1337C13.5789 41.1337 8.22169 38.4906 12.6988 30.1016C20.7347 36.3072 15.7218 42.5128 15.7218 42.5128L13.5789 41.1337Z",
    fill: "white",
    fillOpacity: 0.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M54.0324 41.4571C54.0324 41.4571 52.4252 37.8947 43.2031 37.7031C45.3078 49.4631 54.0324 45.441 54.0324 45.441V41.4571Z",
    fill: "white",
    fillOpacity: 0.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M53.7656 41.4571C53.7656 41.4571 55.3728 37.8947 64.5949 37.7031C62.4903 49.4631 53.7656 45.441 53.7656 45.441V41.4571Z",
    fill: "white",
    fillOpacity: 0.5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M53.0003 59.8435L51.9289 59.4987C51.9672 59.4221 54.7606 50.3436 51.8906 29.122L53.0386 28.9688C55.9085 50.4968 53.1151 59.4987 53.0003 59.8435Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M50.8556 33.4107C50.8556 33.4107 44.6183 30.3462 49.8225 20.5781C59.1594 27.818 53.3429 35.0195 53.3429 35.0195L50.8556 33.4107Z",
    fill: "white",
    fillOpacity: 0.5
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M88.8159 25.0521C88.8159 25.0521 86.9026 20.7618 75.8438 20.5703C78.3693 34.667 88.8159 29.8404 88.8159 29.8404V25.0521Z",
    fill: "white",
    fillOpacity: 0.5
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M88.4688 25.0521C88.4688 25.0521 90.382 20.7618 101.441 20.5703C98.9154 34.667 88.4688 29.8404 88.4688 29.8404V25.0521Z",
    fill: "white",
    fillOpacity: 0.5
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M87.5502 47.0819L86.2492 46.6605C86.2875 46.5456 89.6549 35.6666 86.2109 10.2697L87.5885 10.0781C91.0707 35.8582 87.7033 46.6605 87.5502 47.0819Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M84.9938 15.3991C84.9938 15.3991 77.4936 11.7217 83.7692 0C94.9812 8.65719 87.9785 17.3144 87.9785 17.3144L84.9938 15.3991Z",
    fill: "white",
    fillOpacity: 0.5
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M100.298 66.812H72.2109V61.6406H100.298V66.812Z",
    fill: "#FFD42F"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M103.431 62.0151H75.3438V56.8438H103.431V62.0151Z",
    fill: "#FFEAA5"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M98.0013 57.2338H69.9141V52.0625H98.0013V57.2338Z",
    fill: "#FFD42F"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M99.9857 52.437H71.8984V47.2656H99.9857V52.437Z",
    fill: "#FFEAA5"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M102.439 47.6557H74.3516V42.4844H102.439V47.6557Z",
    fill: "#FFD42F"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M63.2904 66.9995H35.2031V61.8281H63.2904V66.9995Z",
    fill: "#FFD42F"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M65.7747 62.2182H37.6875V57.0469H65.7747V62.2182Z",
    fill: "#FFEAA5"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0872 66.9995H0V61.8281H28.0872V66.9995Z",
    fill: "#FFD42F"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInfobanner1);
export default __webpack_public_path__ + "static/media/icon_infobanner_1.c885d2c868675c0e648c4a86418f4190.svg";
export { ForwardRef as ReactComponent };